var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountHoverstate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30793 8.85902C9.47813 8.85902 11.2374 7.09972 11.2374 4.92951C11.2374 2.7593 9.47813 1 7.30793 1C5.13772 1 3.37842 2.7593 3.37842 4.92951C3.37842 7.09972 5.13772 8.85902 7.30793 8.85902Z",
    fill: "#EE7233",
    stroke: "#EE7233",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6158 15.2773C13.6158 17.3455 10.8238 19 7.30789 19C3.79202 19 1 17.3455 1 15.2773C1 14.0364 2.03408 12.4853 3.68861 11.8649C4.72269 11.4512 5.96359 11.5546 7.30789 11.5546C8.6522 11.5546 9.8931 11.3478 10.9272 11.8649C12.4783 12.4853 13.6158 14.0364 13.6158 15.2773Z",
    fill: "#EE7233",
    stroke: "#EE7233",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountHoverstate);
export default __webpack_public_path__ + "static/media/Account _ hover state.06200fb7eae3e802b0107c72c9493769.svg";
export { ForwardRef as ReactComponent };